import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  ClipboardDocumentListIcon,
  BriefcaseIcon,
  InformationCircleIcon,
  PhoneIcon,
} from '@heroicons/react/24/outline';
import { useAuth } from '../../../core/providers/AuthProvider';
import { confirmAction } from '../../../shared/utils/dialogs';
import BrandHeader from '../../../shared/components/BrandHeader';
import MobileNavDrawer from '../../../shared/components/MobileNavDrawer';

const bottomNavLinks = [
  { label: 'Home', to: '/', icon: HomeIcon },
  { label: 'Records', to: '/records', icon: ClipboardDocumentListIcon },
  { label: 'Disbursements', to: '/projects', icon: BriefcaseIcon },
  { label: 'About', to: '/about', icon: InformationCircleIcon },
  { label: 'Contact', to: '/contact', icon: PhoneIcon },
];

function PublicLayout({ children }) {
  const { pathname } = useLocation();
  const { user, signOut } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    const confirmed = await confirmAction({
      title: 'Log out?',
      text: 'You will need to sign in again to access your account.',
      confirmText: 'Log out',
      danger: true,
    });
    if (confirmed) signOut();
  };

  return (
    <div className="h-dvh w-screen flex flex-col bg-appbg overflow-hidden">
      <BrandHeader onOpenMenu={() => setIsMenuOpen(true)} />

      <MobileNavDrawer
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        user={user}
        onLogout={() => {
          setIsMenuOpen(false);
          handleLogout();
        }}
      />

      <div className="flex-1 w-full overflow-y-auto pb-16 xl:pb-0">
        <main className="flex flex-col items-center p-4 space-y-4 lg:w-3/4 lg:mx-auto">{children}</main>
      </div>

      {/* Bottom tab bar, mobile only, native-app style */}
      <nav className="xl:hidden shrink-0 grid grid-cols-5 border-t border-white/10 bg-navy pb-[env(safe-area-inset-bottom)]">
        {bottomNavLinks.map(({ label, to, icon: Icon }) => {
          const isActive = pathname === to;
          return (
            <Link
              key={label}
              to={to}
              className={`flex flex-col items-center justify-center gap-0.5 py-2 text-xs font-medium transition ${
                isActive ? 'text-gold' : 'text-white/50 hover:text-gold'
              }`}
            >
              <Icon className="h-6 w-6" />
              {label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}

export default PublicLayout;
